<template>
  <div class="section">
    <h1>About</h1>
    <div id="left-side">
      <img alt="headshot" src="@/assets/headshot.jpg" id="headshot">
    </div>
    <div id="right-side">
      Description
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped>


#left-side {
  float: left;
  width: 50%;
  height: 45%;
}

#right-side {
  float: right;
  width: 50%;
  height: 45%;
}
</style>
